(function () {
  const initAnimation = (section) => {
    if (
      !section ||
      !section.classList.contains("media-banner-section") ||
      !section.querySelector(".animate-on-scroll")
    )
      return;

    const texts = section.querySelectorAll(".media-banner__heading, .media-banner__description");
    const text = texts[0];

    if (!text) return;

    ScrollTrigger.create({
      trigger: text,
      start: "50% 95%",
      end: "bottom top",
      onEnter: () => texts.forEach((item) => item.classList.add("animated")),
    });
  };

  initAnimation(document.currentScript.parentElement);

  document.addEventListener("shopify:section:load", function (event) {
    initAnimation(event.target);
  });
})();
